$(function() {

    initSM5AdminMenuButton();

});

function initSM5AdminMenuButton() {

    //console.log('initSM5AdminMenuButton');

    $('.sm5-admin-menu button').on('click', function() {
        console.log('initSM5AdminMenuButton click');
        $(this).parent().toggleClass('sm5-admin-menu-open');
    });

    // $(document).on('click', '.sm5-admin-menu button', function() {
    //     $(this).parent().toggleClass('sm5-admin-menu-open');
    // });
}
